import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { NzPlacementType } from 'ng-zorro-antd/dropdown';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AtwUpdateDbComponent } from 'vhobjects-service/src/services';
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-frame-room-by-category-config',
  templateUrl: './frame-room-by-category-config.component.html',
  styleUrls: ['./frame-room-by-category-config.component.scss']
})
export class AtwFrameRoomByCategoryConfig extends AtwUpdateDbComponent {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() type: any; // xem đang ở page hay admin
  @Output() changeOptionConfig = new EventEmitter<any>();
  isViewAll: boolean = false;
  isCollapsed: boolean = false;
  positionSelect: NzPlacementType = 'bottomCenter';
  dataConfig: any;
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'dieu_chinh_hieu_ung',
      index: 3,
    },
  ];

  public bootstrapIconArrows: any = [
    {
      icon_left: 'bi bi-chevron-left',
      icon_right: 'bi bi-chevron-right',
    },
    {
      icon_left: 'bi bi-arrow-left-short',
      icon_right: 'bi bi-arrow-right-short',
    },
    {
      icon_left: 'bi bi-caret-left-fill',
      icon_right: 'bi bi-caret-right-fill',
    },
    {
      icon_left: 'bi bi-chevron-compact-left',
      icon_right: 'bi bi-chevron-compact-right',
    },
  ];

  fonts = [];
  effect_hover = [];
  customize = [];

  
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public functionService: FunctionService,
    public vhEventMediator: VhEventMediator
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  ngOnInit() {
    this.initData();

    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/frame-products.json'),
    ]).subscribe(([fonts, effects]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.objectChoosing) {
        this.initData();
      }
      if (changes.device) this.device = changes.device.currentValue;
    }
  }


  /** 
   * Hàm này thực hiện khởi tạo dữ liệu
   */
  initData() {
    if (this.objectChoosing && this.device) {
      this.dataConfig = this.objectChoosing[`${this.device}_config`];
    }
  }


  /**
   * Thay đổi mũi tên điều hướng trang
   */
  onChangeArrows(arrows) {
    this.dataConfig.icon_pagination.arrow_left_icon = arrows.icon_left;
    this.dataConfig.icon_pagination.arrow_right_icon = arrows.icon_right;
    this.updateConfig();
  }


  // PHẦN DOTS - Nút phân trang

  /**
   * Kiểu nút slide
   * @param event
   */
  handleSetDotsStyle(event) {
    switch (event) {
      case 'circle':
        this.class['frame-product-category__pagination-list-button--controll']['border-radius'] = 50 + 'px';
        this.class['frame-product-category__pagination-list-button--page-number']['border-radius'] = 50 + 'px';
        this.class['frame-product-category__pagination-list-button--active']['border-radius'] = 50 + 'px';
        this.config[`slick_dots`]['height'] = this.config[`slick_dots`]['width'];
        break;
      case 'rectangle':
        this.class['frame-product-category__pagination-list-button--controll']['border-radius'] = 0 + '%';
        this.class['frame-product-category__pagination-list-button--page-number']['border-radius'] = 0 + '%';
        this.class['frame-product-category__pagination-list-button--active']['border-radius'] = 0 + '%';
        break;
    }

    this.updateConfig();
    this.updateClass();
  }


  /**
   * Kích thước cho nút next/prev
   *  @param event
   *  @param type nút next hay prev
   */
  handleSetButtonSize(event) {
    this.config[`slick_dots`]['width'] = event + 'px';
    this.config['slick_dots']['height'] = event + 'px';
    this.class['frame-product-category__pagination-list-button--controll']['border-radius'] = 50 + 'px';
    this.class['frame-product-category__pagination-list-button--page-number']['border-radius'] = 50 + 'px';
    this.class['frame-product-category__pagination-list-button--active']['border-radius'] = 50 + 'px';
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width)
      this.class['frame-product-category']['width'] = event.width + 'px';
    if (event.height)
      this.class['frame-product-category']['height'] = event.height + 'px';
    this.updateClass();
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
  }


  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[2]);
  }


  /* -------------------------------------------------------------------------------------------------------------------------------------- */
  /*                                                    CÁC HÀM UPDATE DATA LÊN DATABASE                                                    */
  /* -------------------------------------------------------------------------------------------------------------------------------------- */

  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //     [this.device + '_config']: this.config,
  //   }).then((bool: any) => {});
  // }


  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //     [this.device + '_class']: this.class,
  //   }).then((bool: any) => {});
  // }


  // updateStaticData() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //     staticdata: this.objectChoosing.staticdata,
  //   }).then((bool: any) => {});
  // }


  /* -------------------------------------------------------------------------------------------------------------------------------------- */
  /*                                                        CÁC HÀM XỬ LÝ MENU CONFIG                                                       */
  /* -------------------------------------------------------------------------------------------------------------------------------------- */

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu14: false,
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

}
